import * as React from 'react';
import * as models from '../../../utils/models';

import css from './modal.module.scss';

const Modal: React.FC<models.ModalProps> = (props): JSX.Element | null => {
	if (!props.isVisible) return null;

	return (
		<div className={css.modal}>
			<div className={css['modal-body']} style={props.style}>
				<button onClick={props.onClose} className={css['modal-body-close']}>
					&#x2715;
				</button>

				<div className={css['modal-body-inner']}>{props.children}</div>
			</div>
		</div>
	);
};

export default Modal;
